import { Component, EventEmitter, Input, Output, signal, WritableSignal } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

import { SelectItem } from '../../../../shared/models/select-item.model';
import { InputType } from '../../../../shared/models/input.type';
import { ServiceRequestCreationComponent } from '../../pages/service-request-creation/service-request-creation.component';

@Component({
  selector: 'carehub-request-creation',
  imports: [DialogModule, ButtonModule, ServiceRequestCreationComponent],
  providers: [ConfirmationService],
  templateUrl: './request-creation.component.html',
  styleUrl: './request-creation.component.scss',
})
export class RequestCreationComponent {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  requestType: WritableSignal<string> = signal('');
  requestTypes: SelectItem[] = [{ name: 'Service Request', value: 'serviceRequest' }];

  /**
   * Select the request type
   *
   * @param requestType
   */
  selectRequestType(requestType: InputType): void {
    if (!requestType) {
      return;
    }
    this.requestType.set(requestType as string);
  }

  /**
   * Close the request creation dialog
   */
  close(): void {
    this.visible = false;
    this.requestType.set('');
    this.visibleChange.emit(this.visible);
  }
}
